import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/home",
      params: { organizationBusinessUnitId: params.organizationBusinessUnitId },
    });
  },
});
